import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CoffeeBrewingWidget from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CoffeeBrewingWidget />
  </React.StrictMode>
);
